// src/App.jsx
import React from "react";
import { BrowserRouter as Router, Routes, Route } from "react-router-dom";

import Layout from "./components/Layout";
import Home from "./pages/Home";
import Presale from "./pages/Presale";
import Videos from "./pages/Videos";
import Burning from "./pages/Burning";
import Staking from "./pages/Staking";
import Vesting from "./pages/Vesting";
import VestingStrategic from "./pages/VestingStrategic";
import Roadmap from "./pages/Roadmap";
import Tokenomics from "./pages/Tokenomics";
import FAQ from "./pages/FAQ";
import Community from "./pages/Community";
import AdminBurn from "./pages/AdminBurn";
import PrivacyPolicy from "./pages/PrivacyPolicy";
import TermsOfUse from "./pages/TermsOfUse";

function App() {
  return (
    <Router>
      <Layout>
        <Routes>
          <Route path="/" element={<Home />} />
          <Route path="/presale" element={<Presale />} />
          <Route path="/videos" element={<Videos />} />
          <Route path="/burning" element={<Burning />} />
          <Route path="/staking" element={<Staking />} />
          <Route path="/vesting" element={<Vesting />} />
          <Route path="/vestingstrategic" element={<VestingStrategic />} />
          <Route path="/roadmap" element={<Roadmap />} />
          <Route path="/tokenomics" element={<Tokenomics />} />
          <Route path="/faq" element={<FAQ />} />
          <Route path="/community" element={<Community />} />
          <Route path="/adminburn" element={<AdminBurn />} />
          <Route path="/privacy-policy" element={<PrivacyPolicy />} />
          <Route path="/terms-of-use" element={<TermsOfUse />} />
        </Routes>
      </Layout>
    </Router>
  );
}

export default App;
